import React, { useEffect, useState } from "react";
import {
  AccordionContent,
  AccordionItem,
} from "../../components-shadcn/accordion";

import CustomInput from "../../components/CustomInput";
import { ReactComponent as RadioButtomIcon } from '../../assets/radiobutton.svg'
import { ReactComponent as RadioButtomIconDisable } from '../../assets/radiobuttom_disable.svg'

import ButtonSave from "../../../src/components/ButtomSave";
import CustomAccordionTrigger from "../../../src/components/CustomAccordionTrigger";
import { RadioGroup } from "../../../src/components-shadcn/radio-group";
import { Label } from "../../../src/components-shadcn/label";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { toast } from "sonner";
import { useStore } from "../../lib/store";
import { AmplitudeLog } from "../../lib/amplitude";

interface Props {
  openItem: string;
  endereco_entrega_seed: any;
  endereco_cobranca_seed: any;
}
const Address: React.FC<Props> = ({ openItem, endereco_entrega_seed, endereco_cobranca_seed }) => {

  const [loading, set_loading] = useState(false);
  const { set_sync_checkout } = useStore();
  const { id_negocio } = useStore();
  const { id_pedido } = useStore();

  const [can_submit, set_can_submit] = useState(false);
  const [even_billing, set_even_billing] = useState(endereco_cobranca_seed.cep ? "Não" : "Sim");

  const [cepValue, setCepValue] = useState(endereco_entrega_seed.cep || "");
  const [errorCepValue, setErrorSetCepValue] = useState("");
  const [cepVerificado, setCepVerificado] = useState(!!endereco_entrega_seed.cep);

  const [logradouroValue, setLogradouroValue] = useState(endereco_entrega_seed.logradouro || "");
  const [errorLogradouroValue, setErrorSetLogradouroValue] = useState("");

  const [bairroValue, setBairroValue] = useState(endereco_entrega_seed.bairro || "");
  const [errorBairroValue, setErrorSetBairroValue] = useState("");

  const [numeroValue, setNumeroValue] = useState(endereco_entrega_seed.numero || "");
  const [errorNumeroValue, setErrorSetNumeroValue] = useState("");

  const [complementoValue, setComplementoValue] = useState(endereco_entrega_seed.complemento || "");
  const [errorComplementoValue, setErrorSetComplementoValue] = useState("");

  const [referenciaValue, setReferenciaValue] = useState("");
  const [errorReferenciaValue, setErrorSetReferenciaValue] = useState("");

  const [cidadeValue, setCidadeValue] = useState(endereco_entrega_seed.cidade_uf || "");
  const [errorCidadeValue, setErrorSetCidadeValue] = useState("");

  //Endereço para cobranças
  const [cepChargeValue, setCepChargeValue] = useState(endereco_cobranca_seed.cep || "");
  const [errorCepChargeValue, setErrorSetCepChargeValue] = useState("");
  const [cepChargeVerificado, setCepChargeVerificado] = useState(!!endereco_cobranca_seed.cep);

  const [logradouroChargeValue, setLogradouroChargeValue] = useState(endereco_cobranca_seed.logradouro || "");
  const [errorLogradouroChargeValue, setErrorSetLogradouroChargeValue] = useState("");

  const [bairroChargeValue, setBairroChargeValue] = useState(endereco_cobranca_seed.bairro || "");
  const [errorBairroChargeValue, setErrorSetBairroChargeValue] = useState("");

  const [numeroChargeValue, setNumeroChargeValue] = useState(endereco_cobranca_seed.numero || "");
  const [errorNumeroChargeValue, setErrorSetNumeroChargeValue] = useState("");

  const [complementoChargeValue, setComplementoChargeValue] = useState(endereco_cobranca_seed.complemento || "");
  const [errorComplementoChargeValue, setErrorSetComplementoChargeValue] = useState("");

  const [referenciaChargeValue, setReferenciaChargeValue] = useState("");
  const [errorReferenciaChargeValue, setErrorSetReferenciaChargeValue] = useState("");

  const [cidadeChargeValue, setCidadeChargeValue] = useState(endereco_cobranca_seed.cidade_uf || "");
  const [errorCidadeChargeValue, setErrorSetCidadeChargeValue] = useState("");


  const buscarCep = async (valor: string) => {
    console.log("Buscando CEP:", valor);
    const cepLimpo = valor.replace(/\D/g, ""); // remove caracteres não numéricos

    setCepVerificado(false);

    if (cepLimpo.length === 8) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
        const data = await response.json();

        if (!data.erro) {
          setLogradouroValue(data.logradouro);
          setBairroValue(data.bairro);
          setCidadeValue(data.localidade + "/" + data.uf);
          setCepVerificado(true);
          AmplitudeLog("Checkout_Cep", { tipo_interacao: "busca_cep", status_busca: "sucesso" });
        } else {
          toast("CEP não encontrado", {
            action: {
              label: "X",
              onClick: () => console.log("Undo"),
            },
            className: "!bg-red-dark !text-white-primary",
          });
          AmplitudeLog("Checkout_Cep", { tipo_interacao: "busca_cep", status_busca: "falha" });
        }
      } catch (err) {
        console.error("Erro ao buscar CEP:", err);
        AmplitudeLog("Checkout_Cep", { tipo_interacao: "busca_cep", status_busca: "falha" });
      }
    }
  };

  const ChargebuscarCep = async (valor: string) => {
    console.log("Buscando CEP de cobrança:", valor);
    const cepLimpo = valor.replace(/\D/g, ""); // remove caracteres não numéricos

    setCepChargeVerificado(false);

    if (cepLimpo.length === 8) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
        const data = await response.json();

        if (!data.erro) {
          setLogradouroChargeValue(data.logradouro);
          setBairroChargeValue(data.bairro);
          setCidadeChargeValue(data.localidade + "/" + data.uf);
          setCepChargeVerificado(true);
          AmplitudeLog("Checkout_Cep", { tipo_interacao: "busca_cep", status_busca: "sucesso" });
        } else {
          alert("CEP não encontrado");
          AmplitudeLog("Checkout_Cep", { tipo_interacao: "busca_cep", status_busca: "falha" });
        }
      } catch (err) {
        console.error("Erro ao buscar CEP:", err);
        AmplitudeLog("Checkout_Cep", { tipo_interacao: "busca_cep", status_busca: "falha" });
      }
    }
  };

  const create_update_address_hub = async () => {
    AmplitudeLog("Checkout_Etapa_Concluida", { nome_etapa: "Endereço", endereco_cobranca_mesmo: even_billing ? "Sim" : "Não" });
    set_loading(true);

    let obj_request: any = {
      "id_negocio": id_negocio,
      "id_pedido": id_pedido,
      "endereco": {
        "entrega": {
          "id": endereco_entrega_seed.id,
          "cep": cepValue,
          "logradouro": logradouroValue,
          "bairro": bairroValue,
          "cidade_uf": cidadeValue,
          "complemento": complementoValue,
          "ponto_referencia": referenciaValue,
          "numero": numeroValue
        }
      }
    }
    if (even_billing === "Não") {
      obj_request.endereco.cobranca = {
        "id": endereco_cobranca_seed.id,
        "cep": cepChargeValue,
        "logradouro": logradouroChargeValue,
        "bairro": bairroChargeValue,
        "cidade_uf": cidadeChargeValue,
        "complemento": complementoChargeValue,
        "ponto_referencia": referenciaChargeValue,
        "numero": numeroChargeValue
      }
    } else {
      obj_request.endereco.cobranca = {};
    }
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/create_update_address_hub",
        obj_request,
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_loading(false);
        set_sync_checkout(true);
      } else {
        toast(resposta.data.status_code + ": " + resposta.data.msg, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
        set_loading(false);
        return false;
      }
    } catch (erro: any) {
      toast("Erro ao cadastrar empresa: Exception Error", {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      set_loading(false);
      return false;
    }
  };

  function Submit() {
    if (VerifyBlankFields() === false && VerifyErros() === false) {
      create_update_address_hub();
    } else {
      console.log("Tem erros ou cammpos em branco")
    }
  }

  function VerifyErros() {
    if (
      errorCepValue !== ""
    ) {
      return true;
    }
    if (even_billing === "Não" && errorCepChargeValue !== "") {
      return true;
    }
    return false;
  }

  function VerifyBlankFields() {
    if (
      cepValue === "" ||
      logradouroValue === "" ||
      bairroValue === "" ||
      numeroValue === "" ||
      cidadeValue === "" ||
      !cepVerificado
    ) {
      return true;
    }
    if (even_billing === "Não" && (
      cepChargeValue === "" ||
      logradouroChargeValue === "" ||
      bairroChargeValue === "" ||
      numeroChargeValue === "" ||
      cidadeChargeValue === "" ||
      !cepChargeVerificado
    )) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    if (VerifyBlankFields() === false && VerifyErros() === false) {
      set_can_submit(true);
    } else {
      set_can_submit(false);
    }
  },
    [
      cepValue,
      logradouroValue,
      bairroValue,
      numeroValue,
      complementoValue,
      referenciaValue,
      cidadeValue,
      cepVerificado,
      cepChargeValue,
      logradouroChargeValue,
      bairroChargeValue,
      numeroChargeValue,
      complementoChargeValue,
      referenciaChargeValue,
      cidadeChargeValue,
      cepChargeVerificado,
      even_billing
    ]
  )


  return (
    <AccordionItem value="3">
      <CustomAccordionTrigger value="3" openItem={openItem} number={3} title="Endereço" />
      <AccordionContent>
        <p>Insira um endereço para receber seus equipamentos e comunicações da Kinology.</p>
        <div className="flex flex-col gap-y-[1.2rem] mt-[1.2rem]">
          <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem] mt-[1rem]'} gap-y-[1.2rem]`}>
            <CustomInput icon="none" placeholder="Digite" title="CEP" type="cep"
              value={cepValue}
              onChange={(value) => { setCepValue(value); value !== cepValue && buscarCep(value); }}
              error={errorCepValue}
              onError={(e) => {
                setErrorSetCepValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "CEP", mensagem_erro: e });
              }}
              required
            />
            <CustomInput icon="none" placeholder="Digite" title="Logradouro (rua, quadra, etc)" type="generic"
              value={logradouroValue}
              onChange={setLogradouroValue}
              error={errorLogradouroValue}
              onError={(e) => {
                setErrorSetLogradouroValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Logradouro (rua, quadra, etc)", mensagem_erro: e });
              }}
              required
            />
          </div>
          <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem] mt-[1rem]'} gap-y-[1.2rem]`}>
            <CustomInput icon="none" placeholder="Digite" title="Bairro" type="generic"
              value={bairroValue}
              onChange={setBairroValue}
              error={errorBairroValue}
              onError={(e) => {
                setErrorSetBairroValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Bairro", mensagem_erro: e });
              }}
              required
            />
            <CustomInput icon="none" placeholder="123" title="Número" type="generic"
              value={numeroValue}
              onChange={setNumeroValue}
              error={errorNumeroValue}
              onError={(e) => {
                setErrorSetNumeroValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Número", mensagem_erro: e });
              }}
              required
            />
          </div>
          <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem] mt-[1rem]'} gap-y-[1.2rem]`}>
            <CustomInput icon="none" placeholder="Ex: apartamento 123" title="Complemento" type="generic"
              value={complementoValue}
              onChange={setComplementoValue}
              error={errorComplementoValue}
              onError={(e) => {
                setErrorSetComplementoValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Complemento", mensagem_erro: e });
              }}
            />
            <CustomInput icon="none" placeholder="Ex: casa de esquina" title="Ponto de referência" type="generic"
              value={referenciaValue}
              onChange={setReferenciaValue}
              error={errorReferenciaValue}
              onError={(e) => {
                setErrorSetReferenciaValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Ponto de referência", mensagem_erro: e });
              }}
            />
          </div>
          <CustomInput icon="none" placeholder="Digite" title="Cidade/UF" type="generic"
            value={cidadeValue}
            onChange={setCidadeValue}
            error={errorCidadeValue}
            onError={(e) => {
              setErrorSetCidadeValue(e);
              if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Cidade/UF", mensagem_erro: e });
            }}
            required
          />
        </div>
        <p className="mt-[1.3rem]">O endereço informado é o mesmo utilizado para cobranças?</p>
        <RadioGroup defaultValue="option-one" className="mt-[1rem]">
          <div className="flex items-center space-x-2" onClick={() => { set_even_billing("Sim"); AmplitudeLog("checkot_mesmo_cobranca", { tipo_interacao: "alternar_endereco_cobranca", valor_selecionado: "sim" }); }}>
            {
              even_billing === "Sim" ?
                <RadioButtomIcon /> :
                <RadioButtomIconDisable />
            }
            <Label htmlFor="option-one">Sim</Label>
          </div>
          <div className="flex items-center space-x-2" onClick={() => { set_even_billing("Não"); AmplitudeLog("checkot_mesmo_cobranca", { tipo_interacao: "alternar_endereco_cobranca", valor_selecionado: "nao" }); }}>
            {
              even_billing === "Não" ?
                <RadioButtomIcon /> :
                <RadioButtomIconDisable />
            }
            <Label htmlFor="option-two">Não</Label>
          </div>
        </RadioGroup>
        {even_billing === "Não" &&
          <div className="flex flex-col gap-y-[1.2rem] mt-[1.2rem]">
            <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem] mt-[1rem]'} gap-y-[1.2rem]`}>
              <CustomInput icon="none" placeholder="Digite" title="CEP" type="cep"
                value={cepChargeValue}
                onChange={(value) => { setCepChargeValue(value); value !== cepChargeValue && ChargebuscarCep(value); }}
                error={errorCepChargeValue}
                onError={(e) => {
                  setErrorSetCepChargeValue(e);
                  if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "CEP cobrança", mensagem_erro: e });
                }}
                required
              />
              <CustomInput icon="none" placeholder="Digite" title="Logradouro (rua, quadra, etc)" type="generic"
                value={logradouroChargeValue}
                onChange={setLogradouroChargeValue}
                error={errorLogradouroChargeValue}
                onError={(e) => {
                  setErrorSetLogradouroChargeValue(e);
                  if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Logradouro cobrança", mensagem_erro: e });
                }}
                required
              />
            </div>
            <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem] mt-[1rem]'} gap-y-[1.2rem]`}>
              <CustomInput icon="none" placeholder="Digite" title="Bairro" type="generic"
                value={bairroChargeValue}
                onChange={setBairroChargeValue}
                error={errorBairroChargeValue}
                onError={(e) => {
                  setErrorSetBairroChargeValue(e);
                  if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Bairro cobrança", mensagem_erro: e });
                }}
                required
              />
              <CustomInput icon="none" placeholder="123" title="Número" type="generic"
                value={numeroChargeValue}
                onChange={setNumeroChargeValue}
                error={errorNumeroChargeValue}
                onError={(e) => {
                  setErrorSetNumeroChargeValue(e);
                  if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Número cobrança", mensagem_erro: e });
                }}
                required
              />
            </div>
            <div className={`flex ${isMobile ? 'flex-col' : 'flex-row gap-x-[2rem] mt-[1rem]'} gap-y-[1.2rem]`}>
              <CustomInput icon="none" placeholder="Ex: apartamento 123" title="Complemento" type="generic"
                value={complementoChargeValue}
                onChange={setComplementoChargeValue}
                error={errorComplementoChargeValue}
                onError={(e) => {
                  setErrorSetComplementoChargeValue(e);
                  if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Complemento cobrança", mensagem_erro: e });
                }}
              />
              <CustomInput icon="none" placeholder="Ex: casa de esquina" title="Ponto de referência" type="generic"
                value={referenciaChargeValue}
                onChange={setReferenciaChargeValue}
                error={errorReferenciaChargeValue}
                onError={(e) => {
                  setErrorSetReferenciaChargeValue(e);
                  if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Ponto de referência cobrança", mensagem_erro: e });
                }}
              />
            </div>
            <CustomInput icon="none" placeholder="Digite" title="Cidade/UF" type="generic"
              value={cidadeChargeValue}
              onChange={setCidadeChargeValue}
              error={errorCidadeChargeValue}
              onError={(e) => {
                setErrorSetCidadeChargeValue(e);
                if (e) AmplitudeLog("Checkout_Erro_Formulario", { campo_com_erro: "Cidade/UF cobrança", mensagem_erro: e });
              }}
              required
            />
          </div>
        }
        <p className="mt-[2rem] text-red-primary font-[600]">* Indica um campo obrigatório</p>
        <ButtonSave
          className="mt-[1.6rem]"
          icon="none"
          theme={`${!can_submit ? 'lightgreen' : 'darkgreen'}`}
          onClick={() => { Submit() }}
          loading={loading}
        >
          Salvar e continuar
        </ButtonSave>
      </AccordionContent>
    </AccordionItem>
  );
};

export default Address;
